export interface ProductPackage {
  id: string;
  tier: string;
  name: string;
  tagline: string;
  price: number;
  description: string;
  features: string[];
  items: PackageItem[];
  image: string;
  accent: string;
}

export interface PackageItem {
  name: string;
  sku: string;
  link: string;
}

export const packages: ProductPackage[] = [
  {
    id: "origin",
    tier: "Origin",
    name: "The Origin",
    tagline: "Pure Water, Pure Beginnings",
    price: 999,
    description:
      "Our essential under-sink solution brings laboratory-grade filtration to your kitchen. Perfect for families who want exceptional drinking water without compromise.",
    features: [
      "NSF Certified to reduce both Nitrates and Nitrites",
      "Professional Installation Included",
    ],
    items: [
      {
        name: "Thunder Ultrafiltration/Reverse Osmosis Under Sink Water Filter | 1000C",
        sku: "CQE-RO-00101",
        link: "https://crystalquest.com/products/reverse-osmosis-under-sink-water-filter-1000c",
      },
      {
        name: "Brushed Nickel Faucet with 1/4\" Tube (European Handle)",
        sku: "",
        link: "https://crystalquest.com/products/brushed-nickel-faucet-with-1-4-tube-european-handle-1",
      },
      {
        name: "Natural Alkalinize, Ionizer, Mineralizer & Oxidation Cartridge",
        sku: "CQE-RC-04054",
        link: "https://crystalquest.com/products/natural-alkalinize-ionizer-mineralizer-and-oxidation-cartridge",
      },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Luxurious%20modern%20kitchen%20interior%20with%20under%20sink%20water%20filtration%20system%20stainless%20steel%20faucet%20pouring%20crystal%20clear%20water%20into%20glass%20warm%20natural%20lighting%20marble%20countertop%20minimalist%20design%20high%20resolution%20photography&width=800&height=600&seq=origin1&orientation=landscape",
    accent: "sage",
  },
  {
    id: "aspect",
    tier: "Aspect",
    name: "The Aspect",
    tagline: "Complete Home Protection",
    price: 3495,
    description:
      "Whole-house filter of your choice. Engineered for Iowa's water challenges.",
    features: [
      "Professional Installation Included",
    ],
    items: [
      {
        name: "Nitrate Whole House Water Filter",
        sku: "CQE-WH-01131",
        link: "https://crystalquest.com/products/nitrate-whole-house-water-filter",
      },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Modern%20suburban%20home%20exterior%20with%20whole%20house%20water%20filtration%20system%20lush%20green%20lawn%20warm%20golden%20hour%20lighting%20clean%20architectural%20lines%20luxury%20residential%20property%20high%20resolution%20photography%20warm%20neutral%20tones&width=800&height=600&seq=aspect1&orientation=landscape",
    accent: "sage",
  },
  {
    id: "estate",
    tier: "Estate",
    name: "The Estate",
    tagline: "Total Water Wellness Estate",
    price: 6500,
    description:
      "The comprehensive water wellness solution for discerning homeowners. Four integrated systems deliver perfectly filtered water throughout your entire estate.",
    features: [
      "Under-Sink RO System",
      "Two Whole-House Filters of your choice",
      "Pre and post sediment filters",
      "Professional Installation",
    ],
    items: [
      {
        name: "Natural Alkalinize, Ionizer, Mineralizer & Oxidation Cartridge",
        sku: "CQE-RC-04054",
        link: "https://crystalquest.com/products/natural-alkalinize-ionizer-mineralizer-and-oxidation-cartridge",
      },
      {
        name: "Reverse Osmosis Under Sink Water Filter | 2000M",
        sku: "CQE-RO-00110",
        link: "https://crystalquest.com/products/reverse-osmosis-under-sink-water-filter-2000m",
      },
      {
        name: "Nitrate Whole House Water Filter",
        sku: "CQE-WH-01131",
        link: "https://crystalquest.com/products/nitrate-whole-house-water-filter",
      },
      {
        name: "Smart Whole House Water Filter",
        sku: "CQE-WH-01114",
        link: "https://crystalquest.com/products/smart-whole-house-water-filter",
      },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20modern%20home%20interior%20bathroom%20with%20luxury%20fixtures%20spa%20like%20atmosphere%20natural%20stone%20elements%20warm%20ambient%20lighting%20clean%20water%20aesthetic%20high%20end%20residential%20design%20high%20resolution%20photography%20neutral%20warm%20color%20palette&width=800&height=600&seq=estate1&orientation=landscape",
    accent: "sage",
  },
  {
    id: "diamond",
    tier: "Diamond",
    name: "The Diamond",
    tagline: "Ultimate Whole-House Reverse Osmosis",
    price: 13000,
    description:
      "The pinnacle of residential water purification. Hospital-grade reverse osmosis for your entire home, paired with UV sterilization and alkalinizing filtration. For those who accept nothing less than absolute purity.",
    features: [],
    items: [
      {
        name: "Whole House Reverse Osmosis System",
        sku: "CQE-CO-02032K165",
        link: "https://crystalquest.com/products/whole-house-reverse-osmosis-system",
      },
      {
        name: "Big Blue Whole House Water Filter, Alkalizing (Eagle Series)",
        sku: "CQE-WH-20006A",
        link: "https://crystalquest.com/products/big-blue-whole-house-water-filter-eagle-series",
      },
      {
        name: "12 GPM Ultraviolet Water Sterilizer System",
        sku: "CQE-UV-00104",
        link: "https://crystalquest.com/products/ultraviolet-water-sterilizer-system-12",
      },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Luxurious%20modern%20home%20kitchen%20and%20living%20area%20open%20concept%20design%20with%20water%20dispenser%20premium%20appliances%20warm%20natural%20light%20streaming%20through%20large%20windows%20minimalist%20elegant%20interior%20high%20resolution%20photography%20warm%20neutral%20cream%20palette&width=800&height=600&seq=diamond1&orientation=landscape",
    accent: "sage",
  },
];

export interface Feature {
  title: string;
  description: string;
  image: string;
}

export const features: Feature[] = [
  {
    title: "NSF Certified",
    description:
      "The Origin system along with its claims are certified to the highest level (NSF/ANSI standards).",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20premium%20water%20filtration%20cartridge%20system%20stainless%20steel%20components%20soft%20studio%20lighting%20clean%20minimalist%20product%20photography%20warm%20neutral%20background%20high%20resolution%20detail%20shot%20professional%20quality&width=600&height=600&seq=feat1&orientation=squarish",
  },
  {
    title: "Purity you can trust",
    description:
      "NSF-certified reduction of arsenic, barium, cadmium, chromium, copper, fluoride, lead, nitrates, radium, selenium, and TDS (Origin System).",
    image:
      "https://readdy.ai/api/search-image?query=Crystal%20clear%20water%20droplets%20on%20glass%20surface%20macro%20photography%20pure%20clean%20aesthetic%20soft%20natural%20lighting%20minimalist%20composition%20warm%20tone%20high%20resolution%20detail%20shot%20luxury%20water%20brand%20aesthetic&width=600&height=600&seq=feat2&orientation=squarish",
  },
  {
    title: "Regional Water Expertise",
    description:
      "Specialized solutions for your Iowa's unique water challenges. We understand agricultural runoff, hardness, and municipal treatment patterns across the state.",
    image:
      "https://readdy.ai/api/search-image?query=American%20farmland%20landscape%20at%20golden%20hour%20rolling%20green%20fields%20warm%20sunset%20light%20peaceful%20rural%20scenery%20clean%20sky%20minimalist%20composition%20high%20resolution%20photography%20warm%20neutral%20color%20palette&width=600&height=600&seq=feat3&orientation=squarish",
  },
];

export interface Testimonial {
  quote: string;
  name: string;
  location: string;
  image: string;
}

export const testimonial: Testimonial = {
  quote:
    "The Aspect system transformed our home. The water tastes incredible, and knowing my family, friends, and especially our puppy are protected from nitrates and chemicals gives me complete peace of mind. Worth every penny.",
  name: "Morgan Belzer",
  location: "United States",
  image:
    "https://static.readdy.ai/image/4423c9e7c5b9582be3899e7caeaa467a/2205fa8d47177053092a6b61fab3d78c.png",
};

export const stats = [
  { value: "12", label: "Stage Filtration Process" },
  { value: "500+", label: "Homes Served" },
];